import React, { useState, useEffect } from 'react';
import axios from 'utils/axios';
import { TextField, Button, Typography, Box, Paper } from '@mui/material';
import {formatDateTime} from 'utils/functions';
import AuthService from 'services/AuthService';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';


const CommentsComponent = ({ requestId }) => {
    const { t } = useTranslation();

  const [comments, setComments] = useState([]);
  const [commentText, setCommentText] = useState('');
  const [userId] = useState(1);

  useEffect(() => {
    axios
      .get(`requests/${requestId}/comments`)
      .then((response) => {
        setComments(response.data);
      })
      .catch((error) => {
        console.error('Error fetching comments:', error);
      });
  }, [requestId]);

  const handleCommentSubmit = (e) => {
    e.preventDefault();

    if (commentText.trim()) {
      axios
        .post(`/requests/${requestId}/sendcomment`, { text: commentText })
        .then((response) => {
          var comment = {comment: commentText, created: new Date(), createdBy: AuthService.getUsername()};
          setComments([...comments, comment]);
          setCommentText('');
          toast.success(t('comment_submit_success'));
        })
        .catch((error) => {
          toast.error('Error submitting comment. Please try again.');

        });
    }
  };

  return (
    <Box sx={{ marginBottom: 3 }}>
      {/* <Box sx={{ marginBottom: 3 }}>
        <TextField
          label="Write a comment..."
          multiline
          rows={4}
          variant="outlined"
          fullWidth
          value={commentText}
          onChange={(e) => setCommentText(e.target.value)}
        />
        <Box sx={{ marginTop: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCommentSubmit}
            sx={{ padding: '10px 20px' }}
          >
            Submit
          </Button>
        </Box>
      </Box> */}

      {/* Displaying the comments */}
      <Typography variant="h5" sx={{ marginBottom: 2 }}>
        {t('comments')}
      </Typography>

      <Box sx={{ marginTop: 2 }}>
        {comments.map((comment, index) => (
          <Paper
            key={index}
            sx={{
              padding: 2,
              marginBottom: 2,
              backgroundColor: '#f0f0f0',
              textAlign: 'left',
            }}
          >
            <Typography variant="body3">{comment.comment}</Typography>
            <br />
            <br />
            <Typography sx={{ marginTop: 1, display: 'inline', color: '#233333' }}>{comment.createdBy == 'eUprava' ? 'Krajnji korisnik ' : 'Služba '}</Typography>

            <Typography sx={{ marginTop: 1, display: 'inline', color: 'gray' }}>

           {formatDateTime(new Date(comment.created))}
            </Typography>

          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default CommentsComponent;
